export default "__VITE_ASSET__5377f44d__"